module.exports = __webpack_public_path__ + "media/images/icons/filter-52850060e0eec8ed496470f928b69d58.svg";